/** Outro-phase card for the welcome plan tour (closing message). */
import { Button, Paper, Typography } from '@mui/material';
import { useT } from '@/i18n/useT';
import { ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS } from '@/features/onboarding/constants/welcomePlanTour';
import { onboardingHintCardPositionSx } from '@/features/onboarding/utils/onboardingHintCardSx';

/**
 * @param {Object} props
 * @param {'planned' | 'plannedWithMore' | 'unplanned'} props.outroVariant
 * @param {() => void} props.closeOutro
 */
const OnboardingWelcomePlanTourOutro = ({ outroVariant, closeOutro }) => {
  const t = useT();
  const outroKeyByVariant = {
    planned: 'onboarding.outro.planned',
    plannedWithMore: 'onboarding.outro.plannedWithMore',
    unplanned: 'onboarding.outro.unplanned',
  };
  const outroDefaultByVariant = {
    planned: 'Mooi, je eerste stap staat in je planning.',
    plannedWithMore:
      'Mooi, je eerste stap staat in je planning. De andere taken staan klaar in Te plannen: sleep ze erbij en vul je dag.',
    unplanned:
      'Alles staat klaar in Te plannen: sleep een taak naar een moment en vul je dag.',
  };
  const outroKey = outroKeyByVariant[outroVariant] ?? outroKeyByVariant.unplanned;
  const outroDefault =
    outroDefaultByVariant[outroVariant] ?? outroDefaultByVariant.unplanned;
  const closeLabelKey =
    outroVariant === 'unplanned'
      ? 'onboarding.outro.close'
      : 'onboarding.outro.start';
  const closeLabelDefault =
    outroVariant === 'unplanned' ? 'Sluiten' : 'Aan de slag';

  return (
    <Paper
      variant="outlined"
      data-testid={ONBOARDING_WELCOME_PLAN_TOUR_TEST_IDS.outro}
      sx={onboardingHintCardPositionSx}
      role="region"
    >
      <Typography variant="body2" sx={{ mb: 1 }}>
        {t(outroKey, outroDefault)}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ mb: 1.5, display: 'block' }}>
        {t(
          'onboarding.outro.helpHint',
          'Sneltoetsen en uitleg: klik rechtsboven op je initialen → Help.',
        )}
      </Typography>
      <Button variant="contained" size="small" onClick={closeOutro}>
        {t(closeLabelKey, closeLabelDefault)}
      </Button>
    </Paper>
  );
};

export default OnboardingWelcomePlanTourOutro;
